import React, { useState } from "react"
import MetaTags from "react-meta-tags"
import {
  Col,
  Container,
  Row,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"

import ServiceStructure from "../../components/Services/structure/ServiceStructure"

const Plastics = () => {
  const [menu, setMenu] = useState(false)
  const toggle = () => {
    setMenu(!menu)
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Disposal Guidance | REMA</title>
        </MetaTags>
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={12}>
                <h6 className="page-title">Authorization | Plastics</h6>

                <ServiceStructure
                  detailsType="plastics"
                  url="auth-plastics-apply"
                  serviceType="Authorization for the use of Plastics"
                  department="Environmental Compliance  &amp; Enforcement Division"
                />
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Plastics
